<template>
    <ListingTableFilter
        ref="listingTableFilter"
        :filter="filter"
        :valuesHumanized="appliedFilterLabels"
        :filterConfig="filterConfig"
        @updateFilter="updateFilter"
        @updateVisibility="updateVisibility"
        @removeFilter="removeFilter"
    >
        <template #filterDropdownContent>
            <CompassDropdownOption
                v-if="filter.options.corp"
                :label="labels.filter.options.corp"
                :avatar="{ type: 'company' }"
                type="avatar"
                value="company"
            />

            <template v-if="filter.options.staff">
                <li
                    class="listing-filter-dropdown-select-users-parent-option typographies-paragraph-small-semibold"
                >
                    {{ labels.filter.options.staff }}
                </li>

                <CompassDropdownOption
                    v-for="staff in filter.options.staff"
                    :key="`listing-filters-select-users-${staff.code}-${staff.value}`"
                    :label="staff.label"
                    :value="`${staff.code}-${staff.value}`"
                    :avatar="{
                        initials: staff.initials,
                        colorType: staff.colorType,
                        photo: staff.avatar,
                    }"
                    type="avatar"
                />
            </template>

            <template v-if="filter.options.group">
                <li
                    class="listing-filter-dropdown-select-users-parent-option typographies-paragraph-small-semibold"
                >
                    {{ labels.filter.options.group }}
                </li>

                <CompassDropdownOption
                    v-for="group in filter.options.group"
                    :key="`listing-filters-select-users-${group.code}-${group.value}`"
                    :label="group.label"
                    :value="`${group.code}-${group.value}`"
                    :avatar="{ type: 'team' }"
                    type="avatar"
                />
            </template>
        </template>
    </ListingTableFilter>
</template>
<script>
import ListingTableFilter from 'vcomponents/common/listing/filters/ListingTableFilter.vue';

export default {
    components: { ListingTableFilter },
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    emits: ['updateFilter', 'update:displayDropdown', 'removeFilter'],
    data() {
        return {
            labels: {
                filter: {
                    options: {
                        corp: this.$t.__(
                            'listing.filters.types.users.ListingFiltersSelectUsers.labels.corp',
                        ),
                        staff: this.$t.__(
                            'listing.filters.types.users.ListingFiltersSelectUsers.labels.staff',
                        ),
                        group: this.$t.__(
                            'listing.filters.types.users.ListingFiltersSelectUsers.labels.group',
                        ),
                    },
                },
            },
        };
    },
    computed: {
        appliedFilterLabels() {
            return this.filter.optionsSelected
                .map((newDropdownValue) => newDropdownValue.label)
                .join(', ');
        },
        filterConfig() {
            return {
                isVisible: this.filter.displayDropdown,
                filterable: this.filter.filterable,
                multiple: this.filter.multiple,
                appliedButton: this.filter.applyLabel,
                dropdownClass: 'listing-filter-dropdown-select-users',
            };
        },
    },
    watch: {
        'filter.optionsSelected': {
            handler() {
                this.$nextTick(() => {
                    const newFilterValues = [];
                    for (const optionSelected of this.filter.optionsSelected) {
                        let newDropdownValue = `${optionSelected.code}-${optionSelected.value}`;
                        if (optionSelected.code === 'corp') {
                            newDropdownValue = 'company';
                        }

                        newFilterValues.push(newDropdownValue);
                    }

                    this.$refs.listingTableFilter.filterValues = newFilterValues;
                });
            },
        },
    },
    methods: {
        updateFilter(values) {
            const newOptionsSelected = [];
            for (const value of values) {
                let newOptionSelected = {};
                if (value === 'company') {
                    newOptionSelected = {
                        ...this.filter.options.corp,
                        label: this.$t.__(
                            'listing.filters.types.users.ListingFiltersSelectUsers.labels.corp',
                        ),
                    };
                } else {
                    const valueType = value.split('-')[0];
                    const valueId = value.split('-')[1];

                    newOptionSelected = this.filter.options[valueType].find(
                        (filterItem) => filterItem.value === valueId,
                    );
                }

                newOptionsSelected.push(newOptionSelected);
            }

            this.$emit('updateFilter', newOptionsSelected);
            this.updateVisibility(false);
        },
        removeFilter() {
            this.$emit('removeFilter', this.filter.code);
        },
        updateVisibility(visibility) {
            this.$emit('update:displayDropdown', visibility);
        },
    },
};
</script>

<style lang="scss">
.listing-filter-dropdown-select-users-parent-option {
    color: var(--colors-common-text-standard-caption, #8c909c);
    padding: var(--spacing-2) var(--spacing-1) 0;
}

.listing-filter-dropdown-select-users:has(.compass-no-results) {
    .listing-filter-dropdown-select-users-parent-option {
        display: none;
    }
}
</style>
